export const PurposeOfFilingRegexPattern = {
    /**
     * Call signs must begin with the letter K (West of Mississippi) or W (East of Mississippi).
     */
    callSignFirstLetterPattern: /^[KWkw].*$/,
};
